/* eslint-disable camelcase */
import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import fetchAuditoriumByWebinarId from 'network/fetchAuditoriumByWebinarId';
import { Auditorium } from './types';

const auditoriumAdapter = createEntityAdapter<Auditorium>({
  selectId: (auditorium) => auditorium.webinarId,
});

export const {
  selectById: selectAuditoriumByWebinarId,
} = auditoriumAdapter.getSelectors((state: any) => state.auditoriums);

export const fetchAuditoriumById = createAsyncThunk(
  'webinars/fetchAuditoriumByWebinarId',
  async (webinarId: string, { getState, dispatch }) => {
    try {
      const state = getState() as any;
      const { eventConfigs: { features } } = state;
      const hasAuditorium = features.includes('auditoriumWebinar');
      if (!hasAuditorium) {
        return null;
      }
      const auditoriumData = await fetchAuditoriumByWebinarId(webinarId);
      return auditoriumData;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
);

export const auditoriumsSlice = createSlice({
  name: 'auditoriums',
  initialState: auditoriumAdapter.getInitialState({ isLoading: true }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAuditoriumById.pending, (state: any) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAuditoriumById.fulfilled, (state: any, action) => {
      if (action.payload) {
        auditoriumAdapter.upsertOne(state, action.payload);
      }
      state.isLoading = false;
    });
    builder.addCase(fetchAuditoriumById.rejected, (state: any) => {
      state.isLoading = false;
    });
  },
});

export default auditoriumsSlice.reducer;
